import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, teamId) => {
    dispatch({ type: 'LOAD', cycles: null });

    if (teamId) {
      axios
        .get(routes.api.teams.cycles.index(teamId))
        .then((response) => {
          dispatch({ type: 'LOAD', cycles: response.data.data });
        });
    }
  },
};
